import { Box, Checkbox, FormControlLabel } from '@mui/material';
import type { DiscoveryAnswerProps } from './DiscoveryAnswerInput';
import { DISCOVERY_ADDED_CHOICES_LIMIT, DISCOVERY_CHOICE_LIMIT } from './discoveryLimits';
import { InlineAddField } from './InlineAddField';

export const DiscoveryPickAny = ({ question, onAnswer }: DiscoveryAnswerProps) => {
  const value = question.value ?? {};
  const ticked = Array.isArray(value.answer) ? value.answer : [];
  const custom = value.custom_choices ?? [];
  const options = [...(question.choices ?? []), ...custom];

  const toggle = (option: string, on: boolean) =>
    onAnswer({ ...value, answer: on ? [...ticked, option] : ticked.filter((chosen) => chosen !== option) });

  // An option typed the same as one already there ticks that one rather than adding a copy.
  const add = (typed: string) => {
    const existing = options.find((option) => option.toLowerCase() === typed.toLowerCase());
    const option = existing ?? typed;
    onAnswer({
      ...value,
      custom_choices: existing ? custom : [...custom, typed],
      answer: ticked.includes(option) ? ticked : [...ticked, option]
    });
    return null;
  };

  return (
    <Box>
      <Box className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
        {options.map((option) => (
          <FormControlLabel
            key={option}
            label={option}
            control={
              <Checkbox
                size="small"
                checked={ticked.includes(option)}
                onChange={(event) => toggle(option, event.target.checked)}
              />
            }
            slotProps={{ typography: { fontSize: 14 } }}
          />
        ))}
      </Box>
      {custom.length < DISCOVERY_ADDED_CHOICES_LIMIT && (
        <InlineAddField
          label={question.custom_choice_label ?? '+ Add option'}
          maxLength={DISCOVERY_CHOICE_LIMIT}
          onAdd={add}
          buttonProps={{ className: 'mt-1' }}
        />
      )}
    </Box>
  );
};
